import { events } from "./events";

export function changeLoading(loading) {
	return {
		type: events.CHANGE_LOADING,
		payload: {
			loading,
		},
	};
}

export function onStartOnBoardingRequest(id_product) {
	return {
		type: events.START_ONBOARD_REQUEST,
		payload: { id_product },
	};
}

export function onStartOnBoardingSuccess(cd_access_token) {
	return {
		type: events.START_ONBOARD_REQUEST,
		payload: { cd_access_token },
	};
}

export function onStartOnBoardingSuccessToken(cd_access_token) {
	return {
		type: events.START_ONBOARD_SUCCESS,
		payload: { cd_access_token },
	};
}

export function sendNewClientFieldUpdateStatus(data) {
	return {
		type: events.ON_NEW_CLIENT_FIELD_UPDATE_STATUS,
		payload: { data },
	};
}
export function updateNewClientFieldUpdateRequest(field, value, extra) {
	return {
		type: events.ON_NEW_CLIENT_FIELD_UPDATE_REQUEST,
		payload: { field, value, extra },
	};
}
export function onProcessClientCheckoutRequest(payment) {
	return {
		type: events.ON_PROCESS_CLIENT_CHECKOUT_REQUEST,
		payload: { payment },
	};
}

export function onClientCheckoutLoading(loading) {
	return {
		type: events.ON_CLIENT_CHECKOUT_LOADING,
		payload: { loading },
	};
}

export function onClientCheckoutSuccess(data) {
	return {
		type: events.ON_CLIENT_CHECKOUT_SUCCESS,
		payload: { data },
	};
}

export function onClientCheckoutError(error) {
	return {
		type: events.ON_CLIENT_CHECKOUT_SERVICE_ERROR,
		payload: { error },
	};
}

export function dispatchFormIsValid(isValidForm) {
	return {
		type: events.DISPATCH_FORM_IS_VALID,
		payload: { isValidForm },
	};
}

export function changeMainColor(main_color) {
	return {
		type: events.CHANGE_COLOR,
		payload: { main_color },
	};
}

export function sendValidateOnBoarding() {
	return {
		type: events.VALIDATE_ONBOARDING,
		payload: {},
	};
}

export function sendValidateOnboardingStatus(data) {
	return {
		type: events.VALIDATE_ONBOARDING_STATUS,
		payload: { data },
	};
}

export function isUserRegisteredRequest() {
	return {
		type: events.IS_USER_REGISTERED_REQUEST,
		payload: {},
	};
}

export function isUserRegisteredRequestAction() {
	return {
		type: events.IS_USER_REGISTERED_REQUEST,
		payload: {},
	};
}

export function userRegistered(documentUser) {
	return {
		type: events.USER_REGISTERED_ONBOARD,
		payload: { documentUser },
	};
}

export function isUserResgitered(param) {
	return {
		type: events.IS_USER_REGISTERED,
		payload: { param },
	};
}

export function isUserRegisteredData(data) {
	return {
		type: events.IS_USER_REGISTERED_DATA,
		payload: { data },
	};
}

export function twygoInvestorIntegrationData(data) {
	return {
		type: events.TWYGO_INTEGRATION_DATA,
		payload: { data },
	};
}

export function sendGetOnBoardingDataRequest() {
	return {
		type: events.ONBOARDING_DATA_REQUEST,
		payload: {},
	};
}

export function setOnBoardingData(data) {
	return {
		type: events.ONBOARDING_DATA,
		payload: { data },
	};
}

export function setGogogoStatus(data) {
	return {
		type: events.GOGOGO_REQUEST_STATUS,
		payload: { data },
	};
}

export function getTypeRecurrenceDefault(id_product) {
	return {
		type: events.TYPE_PRODUCT_RECURRENCE_DEFAULT,
		payload: { id_product },
	};
}

export function setProductRecurrenceDefault(data) {
	return {
		type: events.PRODUCT_DEFAULT,
		payload: { data },
	};
}

export function createOnboardByTokenRequest(data) {
	return {
		type: events.CREATE_ONBOARD_BY_TOKEN_REQUEST,
		payload: { data },
	};
}

export function setNameAuthenticated(name) {
	return {
		type: events.SET_NAME_AUTHENTICATED,
		payload: { name },
	};
}

export function setTokenLogin(token) {
	return {
		type: events.SET_TOKEN_LOGIN,
		payload: { token },
	};
}

export function setLoading(loading) {
	return {
		type: events.LOADING,
		payload: { loading },
	};
}

export function setUpdatedEmail(updated_email) {
	return {
		type: events.UPDATED_EMAIL,
		payload: { updated_email },
	};
}

export function updateOrigin(origin) {
	return {
		type: events.UPDATE_CLIENT_ORIGIN,
		payload: { origin },
	};
}

export function setUpdatedOrigin(updated_client_origin) {
	return {
		type: events.SET_UPDATED_CLIENT_ORIGIN,
		payload: { updated_client_origin },
	};
}

export function isVerifyingDuplicityEmail(is_verifying_duplicity_email) {
	return {
		type: events.IS_VERIFYING_DUPLICITY_EMAIL,
		payload: { is_verifying_duplicity_email },
	};
}

export function isUpdatingEmail(is_updating_email) {
	return {
		type: events.IS_UPDATING_EMAIL,
		payload: { is_updating_email },
	};
}

export function retryGetCdAccessToken(retry_get_cd_access_token) {
	return {
		type: events.RETRY_GET_CD_ACCESS_TOKEN,
		payload: { retry_get_cd_access_token },
	};
}
